import { useQuery } from "@tanstack/react-query";
import { RecordManagement } from "app/class/record-management";
import queryKeys from "shared/services/queryKeys";

export type AclFieldPermission = "hidden" | "readonly";
export type AclFieldPermissions = Record<string, AclFieldPermission>;

interface UseAclFieldPermissionsInput {
    tableName: string;
    mode: "create" | "edit";
    record?: any;
}

export function useAclFieldPermissions({ tableName, mode, record }: UseAclFieldPermissionsInput) {
    const createPermissionsQuery = useQuery({
        queryKey: queryKeys.records.acl(tableName, "create"),
        enabled: mode === "create" && Boolean(tableName),
        queryFn: () => new RecordManagement(tableName).fieldPermissions("create"),
        staleTime: 1000 * 60,
        retry: (failureCount, error) => (error as any)?.response?.status !== 403 && failureCount < 3,
    });

    if (mode === "edit") {
        return {
            fieldPermissions: (record?.meta?.field_permissions ?? {}) as AclFieldPermissions,
            permissions: record?.meta?.permissions,
            isLoading: false,
            isError: false,
            error: null,
        };
    }

    return {
        fieldPermissions: (createPermissionsQuery.data?.fieldPermissions ?? {}) as AclFieldPermissions,
        permissions: createPermissionsQuery.data?.permissions,
        isLoading: createPermissionsQuery.isLoading,
        isError: createPermissionsQuery.isError,
        error: createPermissionsQuery.error,
    };
}
